import { gql } from '@apollo/client'

export type QueryVars = {
  customerId: string
  subjectId: string
  limit: number
  offset: number
}

export type EmailStatus = {
  code: string
  message: string
}

export type EmailNotificationResponse = {
  id: string
  subject: string
  sentDate: string
  status: EmailStatus
}

export type Response = {
  getEmailNotifications: {
    total: number
    offset: number
    results: EmailNotificationResponse[]
  }
}

const query = gql`
  query ($customerId: String!, $subjectId: String!, $limit: Int!, $offset: Int!) {
    getEmailNotifications(
      customerId: $customerId
      subjectId: $subjectId
      limit: $limit
      offset: $offset
    ) {
      total
      offset
      results {
        id
        subject
        sentDate
      }
    }
  }
`

export default query
